export const isWeCom = /wxwork/i.test(navigator.userAgent);

export const usePassword = location.search.includes('admin=1');

export const createAuth2 = (corpId: string, agentId: string, redirectRri: string, scope: string, state = '') => {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&agentid=${agentId}&redirect_uri=${encodeURIComponent(
    redirectRri
  )}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
};

export const getUrlParams = (url = location.href) => {
  const params: Record<string, any> = {};
  const search = url.split('?')[1] || '';
  search.split('&').forEach((item) => {
    const [key, value] = item.split('=');
    params[key] = decodeURIComponent(value);
  });
  return params;
};

export const loadVConsole = () => {
  const head = document.getElementsByTagName('HEAD').item(0);
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
  return new Promise((resolve, reject) => {
    script.onload = () => {
      // @ts-ignore
      resolve(new window.VConsole());
    };
    script.onerror = (e) => {
      reject(e);
    };
    head?.append(script);
  });
};

export const onLoginSuccess = () => {
  const { redirect } = getUrlParams(location.search);
  if (redirect) {
    location.replace(redirect);
  } else {
    location.reload();
  }
};
